const Menu = [
  {
    label: 'Lobby',
    pathname: '/main',
  },
  {
    label: 'Session',
    pathname: '/session',
  },
  {
    label: 'E-Poster',
    pathname: '/poster/0',
  },
  {
    label: 'Exhibition',
    pathname: '/exhibition',
  },
  {
    label: 'My Page',
    pathname: '/mypage',
  },
];

export default Menu;
